import { Injectable, inject } from '@angular/core';
import {
  HttpHandler,
  HttpInterceptor,
  HttpRequest,
} from '@angular/common/http';
import { AuthService } from '../../../features/auth/services/auth.service';
import apiRoute from '../../../common/constants/api-route';
import { environment } from '../../../../environments/environment';

@Injectable()
export class RequestInterceptor implements HttpInterceptor {
  private auth = inject(AuthService);

  intercept(req: HttpRequest<any>, next: HttpHandler) {
    // Get the auth token from the service.
    if (req.method == 'JSONP') return next.handle(req);

    const headers: Record<string, string> = {
      Authorization: 'Bearer ' + this.auth.authToken,
    };

    // Local development impersonation; the API only honours this in Development
    if (environment.devAuth?.enabled) {
      headers['X-Dev-User'] =
        localStorage.getItem('devUser') || environment.devAuth.defaultUser;
    }

    // Clone the request and replace the original headers with
    // cloned headers, updated with the authorization.
    const authReq = req.clone({
      setHeaders: headers,
      url: apiRoute + req.url,
    });

    // send cloned request with header to the next handler.
    return next.handle(authReq);
  }
}
